import { render } from "./CadastroMunicipio.vue?vue&type=template&id=7ead9013&scoped=true"
import script from "./CadastroMunicipio.vue?vue&type=script&lang=js"
export * from "./CadastroMunicipio.vue?vue&type=script&lang=js"

import "./CadastroMunicipio.vue?vue&type=style&index=0&id=7ead9013&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ead9013"]])

export default __exports__